/**
 * Hide product description when a listed variant is selected.
 * Uses data-hide-on-variant-ids on #ProductDescription-{sectionId}.
 */
(function () {
  const HIDE_ATTR = 'data-hide-on-variant-ids';

  function parseIds(el) {
    if (!el || !el.hasAttribute(HIDE_ATTR)) return null;
    return new Set(
      el
        .getAttribute(HIDE_ATTR)
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    );
  }

  function apply(desc, variantId) {
    const ids = parseIds(desc);
    if (!ids) return;
    const hide = ids.has(String(variantId));
    desc.hidden = hide;
    desc.style.display = hide ? 'none' : '';
  }

  function currentVariantId(sectionId) {
    const input =
      document.querySelector(`#product-form-${sectionId} [name="id"]`) ||
      document.querySelector(`#ProductSubmitButton-${sectionId}`)?.form?.querySelector('[name="id"]') ||
      document.querySelector(`product-info[data-section="${sectionId}"] [name="id"]`);
    return input ? input.value : null;
  }

  function initDescription(desc) {
    const match = desc.id && desc.id.match(/^ProductDescription-(.+)$/);
    if (!match || !parseIds(desc)) return;
    const sectionId = match[1];
    apply(desc, currentVariantId(sectionId));
  }

  function boot() {
    document.querySelectorAll('.product__description[data-hide-on-variant-ids]').forEach(initDescription);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = event?.data?.sectionId;
        const variant = event?.data?.variant;
        if (!sectionId || !variant) return;
        const desc = document.getElementById(`ProductDescription-${sectionId}`);
        if (desc) apply(desc, variant.id);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
